<template>
  <div class="top-navigator" :class="[!topFixed?'nav-empty':'',]">
    <div class="scroll-navi" :class="topFixed?'active':''">
      <div class="logo"></div>
      <div class="touch-dropdown">
        <div class="dropdown">
          <div>
            <div class="dropdown-main">GAMES
              <div>
                <div></div>
              </div>
            </div>
            <div class="options">
              <div class=""><a href="/en/" class="">HOME</a>
                <div></div>
              </div>
              <div class="disable"><a href="/en/games/home" class="">GAMES</a>
                <div></div>
              </div>
              <div class=""><a href="/en/news/" class="">NEWS</a>
                <div></div>
              </div>
              <div class=""><a href="/en/company/" class="">COMPANY</a>
                <div></div>
              </div>
              <div class=""><a href="/en/events/2019/" class="">EVENTS</a>
                <div></div>
              </div>
              <div class=""><a href="/en/partners/" class="">PARTNERS</a>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg"></div>
    </div>
    <div class="mob-nav" :class="topFixed?'scrolled':''">
      <div class="mob-overlay"></div>
      <div class="mob-logo">
        <router-link :to="{ name: 'Home'}">
          <img :src="topFixed?weblogo_b:weblogo_w" class="white">
        </router-link></div>
      <div class="mob-toggle">
        <div class="toggle-cover" @click="mobNavActive= true"><span></span><span></span><span></span><span></span><span></span></div>
      </div>
    </div>
    <div class="mobscroll-nav" :class="topFixed?'scrolled':''">
      <div class="mob-cover">
        <div class="mob-logo"></div>
        <div class="mob-toggle">
          <div class="toggle-cover"><span></span><span></span><span></span></div>
        </div>
      </div>
      <div class="mob-overlay"></div>
    </div>
    <div class="main-navi" :class="topFixed?'active':''">
      <div class="logo-left">
        <router-link :to="{ name: 'Home'}" :class="'nuxt-link-active'">
          <img :src="topFixed?weblogo_b:weblogo_w">
        </router-link>
      </div>
      <div class="menu-right">
        <div class="menu">
          <div class="upper" >
            <router-link :to="{ name: 'Home'}">
              Home
            </router-link>
          </div>
          <div class="upper" >
            <router-link :to="{ name: 'Product'}">
              PRODUCT PLACEMENT
            </router-link>
          </div>
           <div class="upper" >
            <router-link :to="{ name: 'aeonbetgame',params:{game:'aeon bet'}}"  v-text="'AEON BET'"></router-link>
          </div>
          <div class="upper" >
            <router-link :to="{ name: 'aresbetgame',params:{game:'ares bet'}}"  v-text="'ARES BET'"></router-link>
          </div>
          <div class="upper" :class="[miniGmaeMenu?'active':'']" @click="toggleGameMenu">
            <a v-text="'Mini Game'"></a>
          </div>
          <div class="upper" >
            <router-link :to="{ name: 'marblegame',params:{game:'marble mini'}}"  v-text="'Marble Mini'"></router-link>
          </div>
          <div class="upper" >
            <router-link :to="{ name: 'lottogame',params:{game:'lotto world'}}"  v-text="'Lotto World'"></router-link>
          </div>
          
        </div>
        <!--                <div class="main-enquiry">-->
        <!--                  <div class="button">-->
        <!--                    <div class="button-cover"><span></span><span></span><span></span></div>-->
        <!--                  </div>-->
        <!--                </div>-->
      </div>
    </div>
    <div class="nav-enquiry" :class="[miniGmaeMenu?'active':'']">
      <div class="content" v-if="miniGmaeMenu">
        <div class="close" @click="toggleGameMenu">
          <svgIcon :type="'close'"></svgIcon>
        </div>
        <div class="main container">
          <div class="row" v-for="i in $dataManager.getters.games" v-if="i.type=='minigame'">
            <div class="title upper" v-text="i.name"></div>
            <div class="games">
              <div class="game" v-for="g in i.games">
                <router-link :to="{ name: i.type,params:{game:g.name}}">
                  <div class="icon">
                    <img :src="gameIcon(g)" alt="">
                  </div>
                  <div class="name">
                    <span class="upper" v-text="g.name"></span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="nav-slide" :class="[topFixed?'scrolled':'',mobNavActive?'active':'']">
      <div class="slide-bg">
        <div></div>
      </div>
      <div class="slide-banner">
        <div class="pg-logo"><img :src="weblogo_b"></div>
        <div class="close-btn">
          <div class="btn-bg"></div>
          <div class="btn-cover" @click="mobNavActive= false"><span></span><span></span></div>
        </div>
      </div>
      <div class="slide-col down">
        <div class="col-menu">
          <div>
            <div class="item">
              <router-link :to="{ name: 'Home'}">
                Home
              </router-link>
            </div>
          </div>
          <div>
            <div class="item">
              <router-link :to="{ name: 'Product'}">
                Product Placement
              </router-link>
            </div>
          </div>
          <div>
            <router-link :to="{ name: 'aeonbetgame',params:{game:'aeon bet'}}">
            <span class="item capitalize" v-text="'AEON BET'" ></span>
            </router-link>
          </div>
          <div>
            <router-link :to="{ name: 'aresbetgame',params:{game:'ares bet'}}">
            <span class="item capitalize" v-text="'ares Bet'" ></span>
            </router-link>
          </div>
          <div>
            <span class="item capitalize " v-text="'Mini Game'" @click="toggleGameMobMenu('miniGameMobMenu')"></span>
            <div class="row gamelist"  :class="[mobMenu.miniGameMobMenu?'active':'']" v-if="mobMenu.miniGameMobMenu">
              <div class="games">
                <div class="game" v-for="g in $dataManager.findGamesByType('minigame').games" @click="mobMenu.miniGameMobMenu = false,mobNavActive = false">
                  <router-link :to="{ name: 'minigame',params:{game:g.name}}">
                    <div class="icon">
                      <img :src="gameIcon(g)" alt="">
                    </div>
                    <div class="name">
                      <span class="upper" v-text="g.name"></span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <router-link :to="{ name: 'marblegame',params:{game:'marble mini'}}">
            <span class="item capitalize" v-text="'marble Game'"></span>
            </router-link>
          </div>
          <div>
            <router-link :to="{ name: 'lottogame',params:{game:'lotto world'}}">
            <span class="item capitalize" v-text="'lotto Game'" ></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import svgIcon from '@/components/Layout/SvgIcon'

const weblogo_w = require('@/assets/weblogo.png')
const weblogo_b = require('@/assets/weblogob.png')
export default {
  name: "topHeader",
  components: {svgIcon},
  props: ['headerClass', 'scrolled', 'scrollNum'],
  data: function () {
    return {
      weblogo_w: weblogo_w,
      weblogo_b: weblogo_b,
      mobNavActive: false,
      miniGmaeMenu: false,
      mobMenu: {
        miniGameMobMenu: false,
        marbleGameMobMenu: false,
        lottoGameMobMenu: false,
        aresBetGameMobMenu: false,
        aeonGameMobMenu: false,
      },

    }
  },
  computed: {
    game() {
      return this.$dataManager.findGameByName(this.$route.params.game)
    },
    navList() {
      var data = this.$dataManager.getters.navList
      return data
    },
    topFixed() {
      return this.scrolled || this.miniGmaeMenu
    },
    route() {
      return this.$route.name
    }
  },
  methods: {
    gameIcon: function (game) {
      var url = 'images/game/' + game.name + '/mini_icon.png';
      return url
    },
    toggleGameMenu: function () {
      this.miniGmaeMenu = !this.miniGmaeMenu
    },
    toggleGameMobMenu: function (i) {
      console.log(i)
      Object.keys(this.mobMenu).forEach((item) => {
        if (item !== i) {
          this.mobMenu[item] = false
        }
      })
      this.mobMenu[i] = !this.mobMenu[i]
    },
  },
  watch: {
    scrollNum(val, old) {
      this.miniGmaeMenu = false
    },
    '$route': {
      handler: function () {
        this.mobNavActive = false
        window.scrollTo(0, 0);
      },
      deep: true,
      immediate: true
    },
    'game': {
      handler: function () {
        this.miniGmaeMenu = false
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/topHeader';
</style>
